import { extendArray } from "../handlers/types";
import { AbstractJSONModel } from "./master-model";

export enum eCalculationType {
  Planned = 0,
  Used = 1,
  Remaining = 2,
  Status = 3
}

export interface ISupervisionTimeCalculation {
  mon_fri_days: number | null;
  public_holidays: number | null;
  vacation_days: number | null;
  sixth_week_days: number | null;
  sixth_week_hours: number | null;
  seniority_days: number | null;
  supervision_days: number | null;
  mon_fri_day_hours: number | null;
  public_holiday_hours: number | null;
  vacation_hours: number | null;
  seniority_hours: number | null;
  supervision_hours: number | null;
  transferred_time_hours: number | null;
  other_time_hours: number | null;
  pool_hours: number | null;
  school_time_pool_hours: number | null;
  net_working_hours: number | null;
  weekly_hours: number | null;
}

export class SupervisionTimeCalculation
  extends AbstractJSONModel
  implements ISupervisionTimeCalculation
{
  public mon_fri_days: number | null = null;
  public public_holidays: number | null = null;
  public vacation_days: number | null = null;
  public sixth_week_days: number | null = null;
  public sixth_week_hours: number | null = null;
  public seniority_days: number | null = null;
  public supervision_days: number | null = null;
  public mon_fri_day_hours: number | null = null;
  public public_holiday_hours: number | null = null;
  public vacation_hours: number | null = null;
  public seniority_hours: number | null = null;
  public supervision_hours: number | null = null;
  public transferred_time_hours: number | null = null;
  public other_time_hours: number | null = null;
  public pool_hours: number | null = null;
  public school_time_pool_hours: number | null = null;
  public net_working_hours: number | null = null;
  public weekly_hours: number | null = null;
}

@extendArray
export class SupervisionTimeCalculationGroupArray extends Array<SupervisionTimeCalculationGroup> {
  constructor(supervisionTimeCalculationGroups: SupervisionTimeCalculationGroup[]) {
    super(...supervisionTimeCalculationGroups);
    Object.setPrototypeOf(this, Object.create(SupervisionTimeCalculationGroupArray.prototype));
  }
  supervisionTimeCalculationGroupByCalculationType(
    type: eCalculationType
  ): SupervisionTimeCalculationGroup | null {
    return this.find((c) => c.calculationType === type) ?? null;
  }
}

export class SupervisionTimeCalculationGroup {
  public calculationType: eCalculationType | null = null;
  public calculation: SupervisionTimeCalculation | null = null;

  public constructor(calculation: SupervisionTimeCalculation, calculationType: eCalculationType) {
    this.calculation = calculation;
    this.calculationType = calculationType;
  }
}
